<template>
  <cms-product-recommendations-standard :content="{ ...content, recommendedProducts }" />
</template>

<script setup lang="ts">
import type { ProductRecommendations } from '#types/components/cms/product-recommendations'

const props = defineProps<{
  content: ProductRecommendations
}>()

const recommendedProducts = ref<ProductRecommendations['recommendedProducts']>(props.content.recommendedProducts)

watch(
  () => props.content.recommendedProducts,
  // RecToken can change but we need to make sure to have the same impression and click
  (newProducts, oldProducts) => {
    if (newProducts?.length && oldProducts?.length) {
      recommendedProducts.value = newProducts.map((product, i) => ({
        ...product,
        recToken: oldProducts[i]?.id === product.id ? oldProducts[i].recToken : product.recToken
      }))
    }
    else {
      recommendedProducts.value = newProducts
    }
  }
)
</script>
